var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.968 10.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3859"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3279",
    d: "M9.516 6.34v4.455H0V1.269h4.45v.55H.85a.3.3 0 00-.3.3v7.812a.3.3 0 00.3.3h7.812a.3.3 0 00.3-.3V6.337z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3280",
    d: "M9.516 6.34v4.455H0V1.269h4.45v.55H.85a.3.3 0 00-.3.3v7.812a.3.3 0 00.3.3h7.812a.3.3 0 00.3-.3V6.337z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3281",
    d: "M10.968 0v4.452h-.552V1.61a.3.3 0 00-.187-.279.3.3 0 00-.115-.023.3.3 0 00-.214.089L5.276 6.013l-.4-.4.393-.392L9.424 1.07A.3.3 0 009.21.554h-2.7V0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3282",
    d: "M10.968 0v4.452h-.552V1.61a.3.3 0 00-.187-.279.3.3 0 00-.115-.023.3.3 0 00-.214.089L5.276 6.013l-.4-.4.393-.392L9.424 1.07A.3.3 0 009.21.554h-2.7V0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/ShareLink.18d57aca.svg";
export { ForwardRef as ReactComponent };